export default __webpack_public_path__ + "static/media/api.5fe3f9a3.svg";